import { TableCell } from '@mui/material';

import { RowCellStatus } from './row-cell-status';

// ----------------------------------------------------------------------

type Props = {
  key: string;
  status: string;
  headerIndex: number;
  baseTabs: any[];
};

export function RowCellLearningStatus({ key, status, headerIndex, baseTabs }: Props) {
  const normalizedStatus =
    status === 'PENDING_REVIEW'
      ? 'PENDING REVIEW'
      : status === 'NEEDS_REVIEW'
        ? 'NEEDS REVIEW'
        : status;

  return (
    <TableCell key={key || headerIndex}>
      <RowCellStatus
        row={{ status: normalizedStatus }}
        headCellId="status"
        value={normalizedStatus}
        moduleName="learning-queue"
        t={(val: string) =>
          val === 'PENDING_REVIEW'
            ? 'Pending Review'
            : val === 'NEEDS_REVIEW'
              ? 'Needs Review'
              : val === 'APPROVED'
                ? 'Approved'
                : val === 'REJECTED'
                  ? 'Rejected'
                  : val
        }
        baseTabs={baseTabs}
      />
    </TableCell>
  );
}
